import { FC } from 'react';
import { Grid } from '@mui/material';

type EnergyLabelProps = {
  value: string | undefined;
};

const EnergyLabel: FC<EnergyLabelProps> = ({ value }) => {
  let color = '';
  switch (value) {
    case 'NulOld':
    case 'G':
      color = '#D73A2B';
      break;
    case 'F':
      color = '#F16228';
      break;
    case 'E':
      color = '#EB9D21';
      break;
    case 'D':
      color = '#F9EB0C';
      break;
    case 'C':
      color = '#9FB93A';
      break;
    case 'B':
      color = '#49A945';
      break;
    case 'A':
      color = '#1A8E45';
      break;
    default:
      // default knalgroen.
      color = '#198F43';
      break;
  }

  return value ? (
    <Grid
      style={{
        display: 'inline-flex',
        minWidth: '20px',
        padding: '0px 5px',
        height: '20px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '4px',
        background: color,
        color: '#ffffff',
        marginLeft: 'auto',
      }}
    >
      {value}
    </Grid>
  ) : (
    '-'
  );
};

export default EnergyLabel;
